<template>
	<el-tabs v-model="activeTab" type="card">
		<template v-if="$store.state.user.userInfo.type != $api.account.types.TEACHER.value">
			<el-tab-pane label="自主练习" :name="$api.test.types.PRACTICE.key" class="testList">
				<test-list-pane
					:studentId="studentId"
					:type="$api.test.types.PRACTICE.value"
					:category="category"
					key="practise"
				></test-list-pane>
			</el-tab-pane>
		</template>
		<el-tab-pane label="日常测试" :name="$api.test.types.DAILY_TEST.key" class="testList">
			<test-list-pane
				:studentId="studentId"
				:type="$api.test.types.DAILY_TEST.value"
				:category="category"
				key="daily_test"
			></test-list-pane>
		</el-tab-pane>
		<el-tab-pane label="正式考试" :name="$api.test.types.EXAM.key" class="testList">
			<test-list-pane
				:studentId="studentId"
				:type="$api.test.types.EXAM.value"
				:category="category"
				key="exam"
			></test-list-pane>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import CompTestListPane from './CompTestListPane'

export default {
	props: {
		studentId: Number,
		category: String
	},
	data() {
		return {
			activeTab:
				this.$store.state.user.userInfo.type == this.$api.account.types.TEACHER.value
					? this.$api.test.types.DAILY_TEST.key
					: this.$api.test.types.PRACTICE.key
		}
	},

	components: {
		'test-list-pane': CompTestListPane
	}
}
</script>

<style></style>
